import styled from "styled-components";

export const WeekPickerStyle = styled.div`
	display: flex;
	align-items: center;
`;
